import React from 'react';
import Icon from '../openplay/OpenPlayIcon';
import PicklingLogoMark from '../PicklingLogoMark';

const EventListItem = ({
  event,
  fallbackEventImage,
  userLocation,
  getEventTypeIconLabel,
  eventTypeStyles,
  onLocate,
  onApply,
  onShare,
}) => {
  const img = String(event?.organizationLogo || event?.coverImageThumbUrl || event?.coverImageUrl || fallbackEventImage).trim();
  const distanceLabel = userLocation ? (event?.distance || '') : '';
  const eventType = event?.eventType || 'open_game';
  const eventTypeColor = eventTypeStyles?.[eventType]?.color || 'var(--color-primary)';

  return (
    <li className="p-3 space-y-3">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-lg bg-muted overflow-hidden flex-shrink-0">
          {img ? (
            <img src={img} alt={event?.title || 'event'} className="w-full h-full object-cover" loading="lazy" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-muted-foreground">
              <Icon name="PhotoIcon" size={18} />
            </div>
          )}
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <span
              className="inline-flex items-center justify-center w-6 h-6 rounded-full text-[11px] font-bold text-white"
              style={{ background: eventTypeColor }}
            >
              <PicklingLogoMark size={14} className="text-white" />
            </span>
            <p className="text-sm font-semibold text-foreground truncate">{event?.title || '이벤트'}</p>
          </div>
          <div className="mt-1 flex items-center gap-2 text-xs text-muted-foreground caption">
            {userLocation ? <span>{distanceLabel || '거리 계산중'}</span> : <span>거리 표시를 위해 현재 위치를 켜주세요</span>}
          </div>
        </div>

        <button
          type="button"
          onClick={onLocate}
          className="w-10 h-10 rounded-lg border border-border bg-background hover:bg-muted transition-smooth flex items-center justify-center text-muted-foreground hover:text-foreground flex-shrink-0"
          aria-label="지도에서 위치 보기"
        >
          <Icon name="MapPinIcon" size={18} />
        </button>
      </div>

      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => onApply?.(event)}
          className="flex-1 h-9 rounded-lg bg-primary text-primary-foreground text-xs font-semibold"
        >
          참가신청
        </button>
        <button
          type="button"
          onClick={() => onShare?.(event)}
          className="flex-1 h-9 rounded-lg border border-border text-xs text-muted-foreground"
        >
          공유하기
        </button>
      </div>
    </li>
  );
};

export default EventListItem;
